export const MAINTENANCE_ENABLED = window.MAINTENANCE === 'true';
